import React from 'react'
import { SearchDropdown } from '@ui'
import { DepartmentItem } from '@ui/selects/DepartmentSelect'
import { IDepartmentsHook } from './hooks/useDepartments'
import { NavigateFn } from '@reach/router'
import useDepartmentSearch from './hooks/useDepartmentSearch'
import { IDMTableDepartment } from '@api'
import track from '@track'

export default function DepartmentSearch({
  hook,
  navigate,
}: {
  hook: IDepartmentsHook
  navigate?: NavigateFn
}) {
  const { run, items, query, loading } = useDepartmentSearch()
  return (
    <SearchDropdown
      width={'400px'}
      inputPlaceholder="Search by department name"
      search={{ run, items, query, loading }}
      onSelect={(department) => {
        if (!department) return undefined
        navigate?.(`?departmentId=${department.id}`)
        track.departments({
          eventName: track.Event.SEARCH_RESULT_CLICK,
        })
      }}
      queryTableMessage="See all department results for"
      renderItem={(department: IDMTableDepartment) => (
        <DepartmentItem query={query} data={department} />
      )}
      queryTable={(query: string) => {
        if (query || hook.query) hook.search(query)
      }}
    />
  )
}
